import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Sch P Save Service
 * Matches AngularJS schPSaveServiceFactory.saveDetails
 * Uses application/x-www-form-urlencoded and withCredentials per migration rules.
 */
@Injectable({
  providedIn: 'root'
})
export class SchPSaveService {

  constructor(private http: HttpClient) {}

  /**
   * Save Insurance Schedule P data
   * Replicates AngularJS: saveDetails(returnClobSettingsObj, dataToSend)
   * URL: base_url + "/saveJsonObject?action_code=osd69j"
   * process_name: "Save INS Details"
   */
  saveDetails(
    baseUrl: string,
    clobSettings: Record<string, any>,
    detailsArray: any[],
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=osd69j`;

    const jsonObj = JSON.stringify(detailsArray);
    const jsonSettings = JSON.stringify(clobSettings);

    // Merge order: globalParams + filterParams + explicit (matching AngularJS _.merge/_.extend)
    let params: Record<string, any> = {};
    if (globalParams && typeof globalParams === 'object') {
      Object.assign(params, globalParams);
    }
    if (filterParams && typeof filterParams === 'object') {
      Object.assign(params, filterParams);
    }
    params.clob_data = jsonObj;
    params.clob_settings = jsonSettings;
    params.process_name = 'Save INS Details';

    // scenarioCode and is_issue_key_enabled per AngularJS service logic
    const scenarioCode = filterParams?.scenarioCode ?? filterParams?.scenario_code ?? 'RAF';
    let isIssueKeyEnabled = globalParams?.is_issue_key_enabled;
    if (isIssueKeyEnabled === undefined && scenarioCode === 'RAF') {
      isIssueKeyEnabled = 'N';
    } else if (isIssueKeyEnabled === undefined) {
      isIssueKeyEnabled = 'Y';
    }
    params.scenarioCode = scenarioCode;
    params.is_issue_key_enabled = isIssueKeyEnabled;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
